import api from './api';

export const fetchShipments = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.append('page', params.page);
  if (params.page_size) query.append('page_size', params.page_size);
  if (params.search) query.append('search', params.search);
  if (params.shipment_number) query.append('shipment_number', params.shipment_number);
  if (params.status) query.append('status', params.status);
  const res = await api.get(`/admin/shipments/?${query.toString()}`);
  return res.data;
};

export const fetchShipmentById = async (id) => {
  const res = await api.get(`/admin/shipments/${id}/`);
  return res.data;
};

export const createShipment = async (payload) => {
  const res = await api.post('/admin/shipments/create', payload);
  return res.data;
};

export const lookupShipmentPackage = async (packageNumber) => {
  const res = await api.get('/admin/shipments/package-lookup/', {
    params: { package_number: packageNumber }
  });
  return res.data;
};

export const searchShipmentPackages = async (query) => {
  const res = await api.get('/admin/packages/search/', {
    params: { q: query }
  });
  return res.data;
};

export const updateShipment = async (id, payload) => {
  const res = await api.put(`/admin/shipments/${id}/update/`, payload);
  return res.data;
};

export const fetchShipmentCarriers = async () => {
  const res = await api.get('/admin/shipments/carriers/');
  return res.data;
};

export const createShipmentCarrier = async (payload) => {
  const res = await api.post('/admin/shipments/carriers/', payload);
  return res.data;
};

export const deleteShipmentCarrier = async (id) => {
  await api.delete(`/admin/shipments/carriers/${id}/`);
};

export const createManualShipmentEvent = async (id, payload) => {
  const res = await api.post(`/admin/shipments/${id}/manual-event/`, payload);
  return res.data;
};

export const confirmShipmentInternationalFees = async (id, payload = {}) => {
  const res = await api.post(`/admin/shipments/${id}/confirm-international-fees/`, payload);
  return res.data;
};

export const markShipmentSent = async (id) => {
  const res = await api.post(`/admin/shipments/${id}/mark-sent/`, {});
  return res.data;
};

const shipmentService = {
  fetchShipments,
  fetchShipmentById,
  createShipment,
  updateShipment,
  fetchShipmentCarriers,
  createShipmentCarrier,
  deleteShipmentCarrier,
  createManualShipmentEvent,
  confirmShipmentInternationalFees,
  markShipmentSent,
  lookupShipmentPackage,
  searchShipmentPackages,
};

export default shipmentService;
